module.exports = __webpack_public_path__ + "static/01-bb634e135aea93fd2cd607e01c0cea68.jpg";